import React from "react";
import { NavLink } from "react-router-dom";
import { Radio, LayoutDashboard, Shield, ShieldAlert, LogOut } from "lucide-react";
import { useAuth } from "../AuthContext";

export default function Sidebar() {
  const { user, logout } = useAuth();

  const nav = [
    { to: "/",           icon: LayoutDashboard, label: "Channels" },
    ...(user?.role === "admin" || user?.role === "employer"
      ? [
          { to: "/supervisor", icon: Shield,       label: "Supervisor" },
          { to: "/health",     icon: ShieldAlert,  label: "Health" },
        ]
      : []),
  ];

  const linkCls = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
      isActive
        ? "bg-brand text-white"
        : "text-gray-400 hover:bg-gray-800 hover:text-white"
    }`;

  return (
    <aside className="w-60 bg-gray-900 border-r border-gray-800 flex flex-col h-screen sticky top-0">
      {/* Logo */}
      <div className="px-5 py-4 border-b border-gray-800">
        <div className="flex items-center gap-2">
          <Radio className="text-brand w-5 h-5" />
          <span className="font-bold text-white tracking-wide">VoxLane</span>
        </div>
        <p className="text-xs text-gray-500 mt-0.5">Push-to-Talk Platform</p>
      </div>

      {/* Nav */}
      <nav className="flex-1 px-3 py-4 space-y-1">
        {nav.map(({ to, icon: Icon, label }) => (
          <NavLink key={to} to={to} end={to === "/"} className={linkCls}>
            <Icon className="w-4 h-4" />
            {label}
          </NavLink>
        ))}
      </nav>

      {/* User */}
      <div className="px-4 py-4 border-t border-gray-800">
        {user ? (
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-brand flex items-center justify-center text-xs font-bold text-white">
              {(user.full_name || user.email || "?")[0].toUpperCase()}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-white truncate">{user.full_name || user.email}</p>
              <p className="text-xs text-gray-500 capitalize">{user.role}</p>
            </div>
            <button
              onClick={logout}
              title="Sign out"
              className="text-gray-500 hover:text-red-400 transition-colors"
            >
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        ) : null}
      </div>
    </aside>
  );
}
